import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStoreManager } from './local-store-manager.service';
import { SaldoNumber } from '../models/saldonumber.model';

@Injectable()
export class SaldoNumberService
{
  private saldonumberUrl: string = 'api/saldonumbers';

  constructor(
    private http: HttpClient,
    private localStorage: LocalStoreManager) { }

  getsaldonumbers(restr: number): Observable<SaldoNumber[]> {
    let language = this.localStorage.getDataObject("language");
    let sitename = this.localStorage.getDataObject("sitename");
    let endpointUrl = `${this.saldonumberUrl}/${sitename}:${language}:${restr}`;
    return this.http.get<SaldoNumber[]>(endpointUrl);
  }

}

